import { render, staticRenderFns } from "./ActivePolls.vue?vue&type=template&id=f456252e"
import script from "./ActivePolls.vue?vue&type=script&lang=js"
export * from "./ActivePolls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports